"use strict";

// 日付フォーマット
function dateSetFunc(str){
  var objDate = new Date(str);
  // var y = objDate.getFullYear();
  // var m = twoDigit(objDate.getMonth() + 1);
  // var d = twoDigit(objDate.getDate());
  // UTCで取得
  var y = objDate.getUTCFullYear();
  var m = twoDigit(objDate.getUTCMonth() + 1);
  var d = twoDigit(objDate.getUTCDate());
  var ymd = y + "." + m + "." + d;
  str = ymd;
  return str;
}

// 0詰め
function twoDigit(d){
    var d = "0" + d;
    var d2 = d.substr(d.length - 2, 2);
    return d2;
}

// HTML出力処理
function paperOutput(xml,show_num){
  var wk_html='<ul class="bl_listResearch">';
  var cnt=0;
  $(xml).find('entry').each(function(){
    var wk_title=$(this).find('title').text();
    var wk_id=$(this).find('id').text();
    // var wk_date=dateSetFunc($(this).find('updated').text());
    var wk_date=dateSetFunc($(this).find('published').text());
    
    var html = '<li class="bl_listResearch_item"><a href="'+wk_id+'" class="bl_cardResearch" target="_blank" rel="noopener">';
    html = html + '<div class="bl_cardResearch_title">'+wk_title+'</div>';
    html = html + '<div class="bl_cardResearch_date">'+wk_date+'</div>';
    html = html + '</a></li>';

    wk_html=wk_html + html;
    cnt=cnt+1;
    if(cnt >= show_num) {
      return false;
    }
  });
  wk_html=wk_html + '</ul>';
  $("#js_paperResult").html(wk_html);
  MathJax.typeset();
}

//XML読込（arxivから取得）
function paperLoad(xml,show_num=3){
  // const xml = "https://export.arxiv.org/api/query?search_query=(au:Hashimoto+AND+au:Koji)+OR+(au:Fukuma+AND+au:Masafumi)+OR+(au:Yoshioka+AND+au:Koichi)+OR+(au:Sugiyama+AND+au:Katsuyuki)+OR+(au:Yoshida+AND+au:Kentaroh)&start=0&max_results=24&sortBy=lastUpdatedDate&sortOrder=descending";
  console.log('test');
  $(function(){
      $.ajax({ 
          type: "GET", 
          url: xml, 
          dataType: "xml", 
          cache: false, 
          success: function(xml){ 
            paperOutput(xml,show_num);
          }
      }); 
  }); 
}

